import React, { useState } from 'react';
import './styles.scss';
import Question from '../../components/Question';
import Answer from '../../components/Answer';
import Footer from '../../components/Footer';
import { checkEligibility } from '../../utils/checkEligibility';
import StageOneIneligible from '../../compositions/StageOneIneligible';
import Eligible from '../../compositions/Eligible';
import Ineligible from '../../compositions/Ineligible';
import question_data from '../../utils/data';

const ReviewPage = ({ questions, answers, updateAnswers, onHandleChangeLinkClick }) => {
    const [stageOneData, setStageOneData] = useState([]);
    const [stageTwoData, setStageTwoData] = useState([]);

    const [stageOneEligible, setStageOneEligible] = useState();
    const [ineligible, setIneligible] = useState(false);
    const [eligible, setEligible] = useState(false);

    const [showAnswers, setShowAnswers] = useState({});

    /**
     * Sort all the questions into separate arrays for easier output on this screen.
     */
    const setData = () => {
        let stageOneDataLocal = stageOneData;
        let stageTwoDataLocal = stageTwoData;
        let localShowAnswers = {};

        for (const [key, value] of Object.entries(questions)) {
            if (value.stage === 1) {
                stageOneDataLocal.push({
                    question_number: key,
                    question: value.question,
                    answer: answers.hasOwnProperty(key) ? answers[key].text : ' ',
                    link: 'Change',
                });
            }
            if (value.stage === 2) {
                stageTwoDataLocal.push({
                    question_number: key,
                    question: value.question,
                    answer: answers.hasOwnProperty(key) ? answers[key].text : '',
                    link: 'Change',
                });
            }

            localShowAnswers[key] = false;
        }

        setStageOneData(stageOneDataLocal);
        setStageTwoData(stageTwoDataLocal);
        setShowAnswers(localShowAnswers);
    };

    // Run setData() once.
    if (stageOneData.length === 0 && stageTwoData.length === 0) {
        setData();
    }

    const updateAnswersLocal = (answer_key, answer, currentQuestion) => {
        updateAnswers(answer_key, answer, currentQuestion);
    };

    /**
     * Handle what to do when the back or forward footer links are clicked.
     *
     * @param type
     *   Type of action to perform.
     */
    const handleFooterLinkClick = (type) => {
        switch (type) {
            // Go back to the start and clear all answers.
            case 'reset':
                window.location.reload(false);
                break;
            case 'check':
                // Loop through all answers stored and check their eligibility. If only one makes them eligible then the
                // if statement below will catch that before any other possibility.
                Object.entries(answers).forEach((answer) => {
                    checkEligibility(answers, answer[0], setStageOneEligible, setIneligible, setEligible);
                });
                break;
            // View the review page again - mainly if they've seen the ineligible screen this allows them to see the
            // review page again.
            case 'review':
                setStageOneEligible();
                setIneligible(false);
                setEligible(false);
                break;
            case 'submit':
                // @todo Handle user being eligible and submitting their form.
                break;
            case 'back':
                const lastQuestion = Object.entries(question_data).length;

                onHandleChangeLinkClick(lastQuestion);
                break;
            default:
                break;
        }
    };

    if (stageOneEligible === false) {
        return <StageOneIneligible type='review' handleFooterLinkClick={handleFooterLinkClick} />;
    } else if (eligible) {
        return <Eligible handleFooterLinkClick={handleFooterLinkClick} courseApplication={true} />;
    } else if (ineligible) {
        return <Ineligible handleFooterLinkClick={handleFooterLinkClick} />;
    }
    // Code below is duplicated for stage one and stage two so will need updating twice or refactoring into
    // a loop - was in to much of a rush to do so.
    else if (stageOneData || showAnswers) {
        return (
            <div className='wrapper'>
                <div className='furtherHeader'>
                    <h2>Review your answers</h2>
                    <p>Check each of your answers provided below and click change to edit your responses.</p>
                </div>
                <table>
                    <tbody>
                        <tr key='essentialConditions' className='titleRow'>
                            <th className='stageTitle' colSpan='3'>

                                Eligibility Criteria
                            </th>
                        </tr>
                        {stageTwoData.map((data) => {
                            const trKey = 'row' + data.question;
                            const selectedAnswer = answers.hasOwnProperty(data.question_number)
                                ? answers[data.question_number]
                                : null;
                            const linkCellClass =
                                showAnswers[data.question_number] === true ? 'linkCell showAnswer' : 'linkCell';
                            const trOneClass = showAnswers[data.question_number] === true ? 'showAnswer' : '';

                            if (questions[data.question_number].nonQuestion === false) {
                                return (
                                    <>
                                        <tr key={trKey} className={trOneClass}>
                                            <th className='questionCell'>{data.question}</th>
                                            <td className='answerCell'>
                                                {data.answer.length > 0 ? data.answer : 'Skipped'}
                                            </td>
                                            <td className={linkCellClass}>
                                                {showAnswers[data.question_number] === false && (
                                                    <button
                                                        className='changeQuestions'
                                                        onClick={() => onHandleChangeLinkClick(data.question_number)}
                                                    >
                                                        {data.link}
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                        <tr className='answerRow'>
                                            <td
                                                className={showAnswers[data.question_number] === true ? '' : 'empty'}
                                                colSpan='3'
                                            >
                                                {showAnswers[data.question_number] === true && (
                                                    <>
                                                        <Question
                                                            description={questions[data.question_number].description}
                                                            list={questions[data.question_number].list}
                                                            list2={questions[data.question_number].list2}
                                                            descriptionList={
                                                                questions[data.question_number].descriptionList
                                                            }
                                                        />
                                                        <Answer
                                                            currentQuestion={data.question_number}
                                                            type={questions[data.question_number].type}
                                                            answers={questions[data.question_number].answers}
                                                            selectedAnswer={selectedAnswer}
                                                            storeAnswer={updateAnswersLocal}
                                                        />
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    </>
                                );
                            }

                            return <></>;
                        })}

                        <tr key='eligibilityCriteria' className='titleRow'>
                            <th className='stageTitle' colSpan='3'>
                                Essential Conditions
                            </th>
                        </tr>
                        {stageOneData.map((data) => {
                            const trKey = 'row' + data.question;
                            const selectedAnswer = answers.hasOwnProperty(data.question_number)
                                ? answers[data.question_number]
                                : null;
                            const linkCellClass =
                                showAnswers[data.question_number] === true ? 'linkCell showAnswer' : 'linkCell';
                            const trOneClass = showAnswers[data.question_number] === true ? 'showAnswer' : '';

                            return (
                                <>
                                    <tr key={trKey} className={trOneClass}>
                                        <th className='questionCell'>{data.question}</th>
                                        <td className='answerCell'>{data.answer}</td>
                                        <td className={linkCellClass}>
                                            <button
                                                className='changeQuestions'
                                                onClick={() => onHandleChangeLinkClick(data.question_number)}
                                            >
                                                {data.link}
                                            </button>
                                        </td>
                                    </tr>
                                    <tr className='answerRow'>
                                        <td
                                            className={showAnswers[data.question_number] === true ? '' : 'empty'}
                                            colSpan='3'
                                        >
                                            {showAnswers[data.question_number] === true && (
                                                <>
                                                    <Question
                                                        description={questions[data.question_number].description}
                                                        list={questions[data.question_number].list}
                                                        list2={questions[data.question_number].list2}
                                                        descriptionList={
                                                            questions[data.question_number].descriptionList
                                                        }
                                                    />
                                                    <Answer
                                                        currentQuestion={data.question_number}
                                                        type={questions[data.question_number].type}
                                                        answers={questions[data.question_number].answers}
                                                        selectedAnswer={selectedAnswer}
                                                        storeAnswer={updateAnswersLocal}
                                                    />
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>
                <Footer
                    footerType='review'
                    buttonText='Start again'
                    forwardButtonScreen='reset'
                    backButtonText='Back'
                    backButtonScreen='back'
                    aboveFooterText=''
                    aboveFooterTextSize='standard'
                    changeScreen={handleFooterLinkClick}
                />
            </div>
        );
    }
};

export default ReviewPage;
